import React from "react";

import "./protom-family.m.css";

const ProthomFamilyView = () => (
  <div styleName="prothom-family" className="prothom-family">
    A member of the Prothom Alo family
  </div>
);

export default ProthomFamilyView;
